import { createAction, props } from '@ngrx/store';

import { TicketListFilter } from '@main-application/tickets/config/interfaces/ticket-list-filter';
import { RestTicketModel } from '@shared/interfaces/turnover.interface';

/**
 * get ticket list
 */
export const getTicketList = createAction('[Tickets] get ticket list', props<{ assigneeId: number }>());
export const getTicketListSuccess = createAction(
  '[Tickets] get ticket list success',
  props<{ ticketList: RestTicketModel[] }>()
);
export const getTicketListFailed = createAction('[Tickets] get ticket list failed');

/**
 * get property ticket list
 */
export const getPropertyTicketList = createAction(
  '[Tickets] get property ticket list',
  props<{ propertyId: number }>()
);
export const getPropertyTicketListSuccess = createAction(
  '[Tickets] get property ticket list success',
  props<{ ticketList: RestTicketModel[] }>()
);
export const getPropertyTicketListFailed = createAction('[Tickets] get property ticket list failed');

/**
 * mark ticket as done
 */
export const markTicketAsDone = createAction(
  '[Tickets] mark ticket as done',
  props<{ turnoverTicket: RestTicketModel }>()
);
export const markTicketAsDoneSuccess = createAction(
  '[Tickets]  mark ticket as done success',
  props<{ updatedTicket: RestTicketModel }>()
);
export const markTicketAsDoneFailed = createAction('[Tickets] mark ticket as done failed');

export const setTicketListFilter = createAction(
  '[Tickets] set ticket list filter',
  props<{ ticketListFilter: TicketListFilter }>()
);

export const clearTicketStore = createAction('[Tickets] clear Ticket Store');
